/**
 * One width for a filter sitting beside a data grid's search box.
 *
 * The filters above a grid are read as a row: a narrower one collapses until
 * its value truncates to an ellipsis, and a wider one reads as a different
 * control from the search field next to it (AB#6686).
 */
export const FILTER_WIDTH = '190px'
